import Swal from "sweetalert2";
import { getDeviceFingerprint } from "../utils/getDeviceFingerprint";
 
export const handleSessionExpiration = async (error, axios) => {
    const result = await Swal.fire({
        title: "Tu sesión ha expirado.",
        text: "¿Deseas continuar con la sesión?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, continuar",
        cancelButtonText: "No, cerrar sesión",
        confirmButtonColor: "#4A001F",
        cancelButtonColor: "#f0a6b7",
        customClass: {
            actions: "my-actions",
            cancelButton: "swal2-cancel",
            confirmButton: "order-2",
        },
    });
 
    if (result.isConfirmed) {
        try {
            async function refreshToken () {
                const fingerprint = await getDeviceFingerprint();
                const response = await axios.post("refreshToken", { fingerprint }, {
                    withCredentials: true,
                    _skipSessionRefresh: true,
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                if (response.status === 201 || response.status === 200) {
                    window.location.reload();
                    return response;
                }
            };
 
            await refreshToken();
        } catch (refreshError) {
            await Swal.fire({
                icon: "error",
                title: "Error al actualizar la sesión",
                text: "Por favor, inicie sesión nuevamente.",
                showConfirmButton: true,
                confirmButtonColor: "#4A001F",
            });
            localStorage.clear();
            window.location.href = "/login";
            //window.location.href = "/loginMantenimiento";
        }
    } else {
        localStorage.clear();
        window.location.href = "/login";
        //window.location.href = "/loginMantenimiento";
    }
};
